import VideoAssetPicker from "@/videos/components/VideoAssetPicker";
import { Box } from "@mui/material";
import { useEffect } from "react";
import { CustomTypes } from "../../shared-types/v1";
import { SettingsPageContainer, StyledBox } from "../components";
import {
  MergeDataFunction,
  useHandleDynamicSettings,
} from "../useHandleDynamicSettings";

const WelcomeVideoManagement = () => {
  const {
    data,
    mergeData,
    handleSave,
    isTouched,
    dataLoading,
    handleGetAppSettings,
  } = useHandleDynamicSettings();
  useEffect(() => {
    handleGetAppSettings();
  // Deps intentionally omitted: handleGetAppSettings is redefined on every render, so listing it would re-run this effect continuously.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <SettingsPageContainer
      handleSave={handleSave}
      isTouched={isTouched}
      dataLoading={dataLoading}
      title="Settings for welcome video"
    >
      <StyledBox
        title={"Welcome video settings"}
        description={"This setting defines the asset for the welcome video."}
      >
        <WelcomeVideoSettings
          mergeData={mergeData}
          data={data?.welcomeVideoAssetId}
        />
      </StyledBox>
    </SettingsPageContainer>
  );
};

const WelcomeVideoSettings = ({
  mergeData,
  data,
}: {
  mergeData: MergeDataFunction;
  data: CustomTypes.DynamicAppSettings["welcomeVideoAssetId"];
}) => {
  const onUpdate = (key: string, value: any) => {
    mergeData({
      welcomeVideoAssetId: value,
    });
  };

  return (
    <Box>
      <VideoAssetPicker
        initialSelectionIds={data || ""}
        onSelectionChange={(selected) => {
          onUpdate("asset_id", selected?.id);
        }}
      />
    </Box>
  );
};

export default WelcomeVideoManagement;
